module.exports = __webpack_public_path__ + "media/customizations/somersett/back-b872b68d0c2211a249c78187c9febd76.jpg";